import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid grid-cols-[auto_1fr] min-h-full bg-white" };
const _hoisted_2 = { class: "min-w-0 px-5 pt-6 pb-4 bg-white" };
const _hoisted_3 = { class: "max-w-270 mx-auto" };
const _hoisted_4 = { class: "text-2xl sm:text-3xl font-bold text-(--colors-text-heading)" };
const _hoisted_5 = {
    class: "flex flex-col items-center justify-center text-center py-24",
    "data-testid": "compliance-landing"
};
const _hoisted_6 = { class: "text-lg font-semibold text-(--colors-text-heading) mb-2" };
const _hoisted_7 = { class: "max-w-md text-sm text-(--colors-text-body-subtle)" };
import { shallowRef } from "vue";
import { moduleRegistry } from "@/router/moduleRegistry";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ComplianceView',
    setup(__props) {
        const SidebarComponent = shallowRef(moduleRegistry.getComponentForSlot("sidebar"));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (SidebarComponent.value)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(SidebarComponent.value), { key: 0 }))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("main", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("compliance.title")), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-shield-check-line text-5xl text-(--colors-text-body-subtle) mb-4" }, null, -1 /* CACHED */)),
                            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("compliance.landing.heading")), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("compliance.landing.description")), 1 /* TEXT */)
                        ])
                    ])
                ])
            ]));
        };
    }
});
